import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './assets/css/bootstrap.min.css'
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { FetchProvider } from './context/FetchContext';
import QueryProvider from './context/QueryContext';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
        <FetchProvider>
          <QueryProvider>
            <App />
          </QueryProvider>
        </FetchProvider>
      </AuthProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
